export enum GridKeyEnum {
  CONTENT = 'Content',
  USERS = 'Users',
  GROUPS = 'Groups',
  SAVEDQUERIES = 'SavedQueries',
  TRASH = 'Trash',
  CONTENTTYPES = 'ContentTypes',
  CONTENTTEMPLATES = 'ContentTemplates',
  SETTINGS = 'Settings',
  LOCALIZATION = 'Localization',
  WEBHOOKS = 'WebHooks',
  SEARCHRESULTS = 'SearchResults',
  OTHER = 'Other',
}
